document.addEventListener('DOMContentLoaded', () => {
  const blocks = document.querySelectorAll<HTMLElement>('.b-collapsible-block')

  blocks.forEach(initCollapsibleBlock)

  function initCollapsibleBlock(block: HTMLElement) {
    let isCollapsed = false
    const content = block.querySelector<HTMLElement>('.b-collapsible-block__content')

    if (!content) { return }

    const heightAttr = content.dataset.maxCollapsedHeight
    const maxCollapsedHeight = heightAttr ? parseInt(heightAttr, 10) : null

    if (!maxCollapsedHeight || content.scrollHeight <= maxCollapsedHeight) {
      block.querySelector<HTMLDivElement>('.b-collapsible-block__btn-more')?.remove()
      block.querySelector<HTMLDivElement>('.b-collapsible-block__btn-less')?.remove()
      block.classList.remove('b-collapsible-block--collapsed')
      isCollapsed = false

      return // Нет необходимости сворачивать
    }

    // Применяем стили свёрнутого состояния
    content.style.maxHeight = `${maxCollapsedHeight}px`
    block.classList.add('b-collapsible-block--collapsed')
    isCollapsed = true

    const btnMore = getOrCreateButton(block, 'more')
    const btnLess = getOrCreateButton(block, 'less')

    btnLess.style.display = 'none'

    btnMore.addEventListener('click', () => {
      content.style.maxHeight = `${content.scrollHeight}px`

      // После завершения анимации — убираем max-height
      const onTransitionEnd = () => {
        if (!isCollapsed) {
          content.style.maxHeight = ''
        }

        content.removeEventListener('transitionend', onTransitionEnd)
      }

      content.addEventListener('transitionend', onTransitionEnd)

      isCollapsed = false
      block.classList.remove('b-collapsible-block--collapsed')
      btnMore.style.display = 'none'
      btnLess.style.display = 'flex'
    })

    btnLess.addEventListener('click', () => {
      content.style.maxHeight = `${content.scrollHeight}px`

      // Нужно принудительно "перерисовать" перед изменением, чтобы transition сработал
      requestAnimationFrame(() => {
        content.style.maxHeight = `${maxCollapsedHeight}px`
      })

      isCollapsed = true
      block.classList.add('b-collapsible-block--collapsed')
      btnLess.style.display = 'none'
      btnMore.style.display = 'flex'
    })
  }

  function getOrCreateButton(block: HTMLElement, type: 'more' | 'less'): HTMLDivElement {
    const classSuffix = type === 'more' ? 'b-collapsible-block__btn-more' : 'b-collapsible-block__btn-less'
    let btn = block.querySelector<HTMLDivElement>(`.${classSuffix}`)

    if (!btn) {
      btn = document.createElement('div')
      btn.className = `${classSuffix} b-button b-button_light text-button text-none`
      block.appendChild(btn)
    }

    return btn
  }
})
